const localhost = "http://localhost";
const port = "3000";

const cloud_url = "https://data.spellstudy.com";

const baseUrl = `${cloud_url}`;

// const baseUrl = `${localhost}:${port}`;

// Export the base URL
export default baseUrl;
